import { flatM } from "@/lib/nav";

const DELAY_S = { traffic: 480, accident: 720, closed: 1200, flood: 600, ice: 300, hail: 300, fog: 180, rain: 120 };
const LIFE_H = { traffic: 3, accident: 3, closed: 12, flood: 12, ice: 6, hail: 2, fog: 4, rain: 3 };
const NEAR_M = 300;

const nearestIdx = (coords, p) => {
  let best = 0, bd = Infinity;
  for (let i = 0; i < coords.length; i += 4) { const d = flatM(p, coords[i]); if (d < bd) { bd = d; best = i; } }
  for (let i = Math.max(0, best - 4); i < Math.min(coords.length, best + 5); i++) { const d = flatM(p, coords[i]); if (d < bd) { bd = d; best = i; } }
  return [best, bd];
};

// Community reports near the route, each with an estimated delay that fades with report age
export function routeIncidents(nav, reports) {
  if (!nav) return [];
  const now = Date.now();
  const all = reports.map((r) => {
    if (!DELAY_S[r.type]) return null;
    const [idx, d] = nearestIdx(nav.coords, [r.lat, r.lon]);
    if (d > NEAR_M) return null;
    const w = 1 - (now - new Date(r.created_at).getTime()) / 3.6e6 / LIFE_H[r.type];
    if (w <= 0) return null;
    const delay_s = Math.round(DELAY_S[r.type] * w * Math.min(2, 1 + 0.25 * (r.confirmations || 0)));
    return { id: r.id, type: r.type, lat: r.lat, lon: r.lon, confirmations: r.confirmations, km: nav.cum_km[idx], delay_s };
  }).filter(Boolean).sort((a, b) => b.delay_s - a.delay_s);
  // Same-type reports within 500 m count once (largest delay kept)
  const kept = all.filter((x, i) => !all.slice(0, i).some((y) => y.type === x.type && Math.abs(y.km - x.km) < 0.5));
  return kept.sort((a, b) => a.km - b.km);
}

export const delayAhead = (incidents, doneKm = 0, capS = Infinity) =>
  Math.min(capS, incidents.filter((i) => i.km > doneKm).reduce((a, i) => a + i.delay_s, 0));
